import React, { Suspense } from 'react';
import { client } from 'api';
import theme from './theme';
import AppRoutingContainer from 'routes';
import { hot } from 'react-hot-loader/root';
import Authentication from 'services/Authentication';
import CssBaseline from '@material-ui/core/CssBaseline';
import RootStore, { RootStoreContext } from 'stores/index';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { CatchAllErrorBoundary } from 'services/Error/CatchAll';
import { NotificationService } from 'services/NotificationService';
import { BrowserSupportErrorBoundary } from 'services/Error/BrowserSupport';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';

import '@material-ui/data-grid/';
import 'regenerator-runtime/runtime';
import 'mobx-react/batchingForReactDom';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

import '../public/styles.css';
import { Loader } from './components/Loader';
import { PerformanceDataListener } from './components/PerformanceDataListener/PerformanceDataListener';

const HotApp = hot(AppRoutingContainer);

const store = new RootStore();
// addBanner div is, added to check the adBlocker
// tested in chrome with uBlock and AdBlock
// tested in safari with AdBlock
// tested in mozilla with turned off enhanced tracking protection and AdBlock

const App = (
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserSupportErrorBoundary>
      <div className="adBanner" id="ad_banner_id" />
      <CatchAllErrorBoundary
        onException={(err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        }}
        onLogout={Authentication.signOut}
      >
        <ApolloHooksProvider client={client}>
          <RootStoreContext.Provider value={store}>
            <NotificationService>
              <PerformanceDataListener />
              <Suspense fallback={<Loader />}>
                <HotApp />
              </Suspense>
            </NotificationService>
          </RootStoreContext.Provider>
        </ApolloHooksProvider>
      </CatchAllErrorBoundary>
    </BrowserSupportErrorBoundary>
  </MuiThemeProvider>
);

export default App;
